module.exports = __webpack_public_path__ + "img/fondo-header.645dd2d6.jpg";